export default __webpack_public_path__ + "static/media/insta.76cb00eb.png";